export const REDUCER_NAME = 'globals'




// WEBPACK FOOTER //
// ./src/modules/globals/state/const.js